<template>
  <div>
    <v-row dense>
      <v-col cols="2">
        <input_decimal label="" prefix="" :amount="wizardData.minpurchase_quantity" field="minpurchase_quantity" @updateData="updateData"/>
      </v-col>
      <v-col cols="9" offset="1">
        <pa_radioset :value="wizardData.minpurchase_operator" field="minpurchase_operator" :showNightsOption="true" @updateData="updateData"/>
      </v-col>
    </v-row>
  </div>      
</template>

<script>

  import pa_radioset from '@/components/huis/hspt/ui/pa_radioset.vue';
  import input_decimal from '@/components/huis/hspt/ui/input_amount.vue';

  export default {
    props: {
      wizardData: Object
    },
    components: {
      pa_radioset,
      input_decimal,
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);
      },
    },
  }
</script>

<style scoped>
</style>